import AbstractComponent from "./abstract-component";
import gsap from "gsap";

const DURATION = 0.45;
const EASE = "power3.out";

export default class Faq extends AbstractComponent {
	constructor(el) {
		super(el);
		this.initDomElements();
		this.initEvents();
	}

	initDomElements() {
		this.items = [...this.$el.querySelectorAll(".js-faq-item")];
	}

	initEvents() {
		this.items.forEach((item) => {
			const toggle = item.querySelector(".js-faq-toggle");
			toggle?.addEventListener("click", () => this.toggle(item));
		});
	}

	toggle(item) {
		const isOpen = item.classList.contains("is-open");
		if (isOpen) {
			this.close(item);
		} else {
			// Only one item open at a time
			this.items.forEach((other) => {
				if (other !== item && other.classList.contains("is-open")) {
					this.close(other);
				}
			});
			this.open(item);
		}
	}

	open(item) {
		const answer = item.querySelector(".js-faq-answer");
		const toggle = item.querySelector(".js-faq-toggle");
		if (!answer) return;

		item.classList.add("is-open");
		toggle?.setAttribute("aria-expanded", "true");

		gsap.to(answer, {
			height: answer.scrollHeight,
			duration: DURATION,
			ease: EASE,
			onComplete: () => {
				// Allow natural reflow (e.g. window resize) once opened
				answer.style.height = "auto";
			},
		});
	}

	close(item) {
		const answer = item.querySelector(".js-faq-answer");
		const toggle = item.querySelector(".js-faq-toggle");
		if (!answer) return;

		item.classList.remove("is-open");
		toggle?.setAttribute("aria-expanded", "false");

		gsap.to(answer, {
			height: 0,
			duration: DURATION,
			ease: EASE,
		});
	}

	destroy() {}
}
